module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAAAXNSR0IArs4c6QAAAJpJREFUKFOtjzEOQVEQRc8NjcICrMEClBI9iSXovkRjGToNWjug1BG7sAOVSqG7MvKfTOKXXnVn5uTmPJGe7TZwBUaSXuWkEmxH3gBzYC1p2QQNgUsqjrZzzJ8m2z3gBnQT9AD6ku6y3QIOwDj71fkoaRpQOGwbgLJaBDQAOkCIThJ8AlbAM/9uB1QJ2kuafcVr+f9BP06Swok3Ilg4pbS7vdoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-up(1).png
// module id = U2mR
// module chunks = 1